(function ($, Global) {
    var urlParams = new UrlParams();
    var ContactModalComponent = function () {
        // Déclaration class objet
    }

    ContactModalComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    }

    ContactModalComponent.prototype.publishers = function () {
        $(document).ready(function () {
            if (urlParams.getParam('contact')) {
                $.Topic('contact-modal-show').publish();
            }
        });
    }

    ContactModalComponent.prototype.subscribers = function () {
        var self = this;
        $.Topic('contact-modal-show').subscribe(function (context, options) {
            var origin = options && options.origin ? options.origin : '';
            var modalId = 'modalIdentify' + (context || '') + origin;

            if ($('#' + modalId).exists()) {
                return $('#' + modalId).modal('show')
            }

            $.Topic('loader-show').publish();

            $.ajaxGet('/ajax/contact')
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: function () {
                            $('body').append(self.templateModal(result.data.html, modalId, context));
                            Global.initComponentFormContactModal();
                            $('#' + modalId).modal('show').on('shown.bs.modal', function () {
                                $.Topic('loader-hide').publish();
                            });
                        }
                    });
                });
        });

        $.Topic('contact-modal-hide').subscribe(function (context, options) {
            var origin = options && options.origin ? options.origin : '';
            var modalId = 'modalIdentify' + (context || '') + origin;
            if ($('#' + modalId).exists()) {
                return $('#' + modalId).modal('hide')
            }
        });
    }

    ContactModalComponent.prototype.templateModal = function (contentHtml, id, context) {
        return [
            '<div id="' + id + '" class="modal fade modal-simple contact-modal" tabindex="-1" role="dialog">',
            '<div class="modal-dialog modal-borders modal-shadow" role="document">',
            '<div class="modal-content"><button type="button" class="close close-variant" data-dismiss="modal" aria-label="Close"><span class="icon icon-112" aria-hidden="true"></span></button>',
            contentHtml,
            '</div>',
            '</div>',
            '</div>'
        ].join('')
    }

    Global.ContactModalComponent = ContactModalComponent;
}(jQuery, window));